/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaListDialog from 'DesignSystem/TysiaListDialog/index'
import TysiaListDialogItems from 'DesignSystem/TysiaListDialog/TysiaListDialogItems/react'
import TysiaListDialogSaveAction from 'DesignSystem/TysiaListDialog/TysiaListDialogSaveAction/index'
import TysiaListDialogTitle from 'DesignSystem/TysiaListDialog/TysiaListDialogTitle/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Tasks/New/Content/Board/Content/Main/Subscribers/Content/EmployeeTable/Content/ActionsAction/Content/Content/EditStagesAction/StagesDialog/Content",
  title
  
}) {
let stagesStagesValueData = fromData.useDataValue({ viewPath,
context: 'stages',
path: 'stages',
})
let stagesSelectedValueData = fromData.useDataValue({ viewPath,
context: 'stages',
path: 'selected',
})
let onSubmit = fromHelpers.useOnSubmit({
  children,
  viewPath,
  title
  
})
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtSpaceLs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ls'
        })
  return (<React.Fragment
>
<TysiaListDialog
  viewPath={`${viewPath}/TysiaListDialog`}
 height="auto"
 maxHeight={400}
 data="stages.stages"
 items={stagesStagesValueData}
 isMultiChoice={true}
 data="stages.selected"
 selected={stagesSelectedValueData}
 onSubmit={onSubmit}
>
{childProps => (
<React.Fragment>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 style={{'--pt-1-Z1Yf8zk': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--pr-2-Z1Yf8zk': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--pb-3-Z1Yf8zk': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--pl-4-Z1Yf8zk': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaListDialogTitle
  viewPath={`${viewPath}/TysiaListDialogTitle`}
 title={title}
/>
<TysiaListDialogSaveAction
  viewPath={`${viewPath}/TysiaListDialogSaveAction`}
/>
</div>
<TysiaListDialogItems
{...childProps}
  viewPath={`${viewPath}/TysiaListDialogItems`}
 itemDataContextName="item"
/>
</React.Fragment>
)}
</TysiaListDialog>
{children}
</React.Fragment>)
}